import { Component } from '@angular/core';
import {NavbarComponent} from "../navbar/navbar.component";
import {ActivatedRoute, NavigationEnd, Router, RouterLink, RouterOutlet} from "@angular/router";
import {NavbarItemComponent} from "../navbar-item/navbar-item.component";
import {SharedModule} from "../../../shared/shared.module";
import {LanguageSelectorComponent} from "../../default/language-selector/language-selector.component";
import {TranslateModule} from "@ngx-translate/core";
import {LoadingBarModule} from "@ngx-loading-bar/core";
import {AdminAccessDirective} from "../../../directives/admin-access.directive";
import { Observable, map, filter, startWith } from 'rxjs';
import {AsyncPipe, NgIf} from "@angular/common";

@Component({
  selector: 'app-layout',
  standalone: true,
  imports: [
    NavbarComponent,
    RouterOutlet,
    NavbarItemComponent,
    RouterLink,
    SharedModule,
    TranslateModule,
    LanguageSelectorComponent,
    LoadingBarModule,
    AdminAccessDirective,
    NgIf,
    AsyncPipe,
  ],
  templateUrl: './layout.component.html',
  styleUrl: './layout.component.scss'
})
export class LayoutComponent {
  standalone$: Observable<boolean> = this.router.events.pipe(
    filter(event => event instanceof NavigationEnd),
    startWith(null),
    map(() => this.checkIfStandalone())
  );

  constructor(private router: Router, private activatedRoute: ActivatedRoute) {}

  private checkIfStandalone(): boolean {
    let route = this.activatedRoute;

    // Traverse to the deepest child route
    while (route.firstChild) {
      route = route.firstChild;
    }

    // Check if any route in the chain has standalone: true
    let currentRoute: ActivatedRoute | null = route;
    while (currentRoute) {
      if (currentRoute.snapshot.data['standalone'] === true) {
        return true;
      }

      currentRoute = currentRoute.parent;
    }

    return false;
  }
}
